import { render } from "./CheckboxInputComponent.vue?vue&type=template&id=2d804c74&scoped=true"
import script from "./CheckboxInputComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxInputComponent.vue?vue&type=script&lang=js"

import "./CheckboxInputComponent.vue?vue&type=style&index=0&id=2d804c74&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d804c74"]])

export default __exports__